/**
 * Super admin query key factory
 */
export const superAdminKeys = {
  all: ["superadmin"] as const,

  // Stats
  stats: () => [...superAdminKeys.all, "stats"] as const,

  // Companies
  companies: () => [...superAdminKeys.all, "companies"] as const,
  companiesList: (params: {
    search?: string;
    page?: number;
    size?: number;
    include_inactive?: boolean;
  }) => [...superAdminKeys.companies(), "list", params] as const,
  // Separate key space for the infinite (scroll-paginated) picker so its
  // accumulated pages never collide with the single-page table list above.
  companiesInfinite: (params: {
    search?: string;
    size?: number;
    include_inactive?: boolean;
  }) => [...superAdminKeys.companies(), "infinite", params] as const,
  company: (id: string) =>
    [...superAdminKeys.companies(), "detail", id] as const,

  // Users
  users: () => [...superAdminKeys.all, "users"] as const,
  usersList: (params: {
    search?: string;
    company_id?: string;
    page?: number;
    size?: number;
    include_inactive?: boolean;
  }) => [...superAdminKeys.users(), "list", params] as const,
  // Separate key space for the infinite (scroll-paginated) picker so its
  // accumulated pages never collide with the single-page table list above.
  usersInfinite: (params: {
    search?: string;
    company_id?: string;
    size?: number;
    include_inactive?: boolean;
  }) => [...superAdminKeys.users(), "infinite", params] as const,
  user: (id: string) => [...superAdminKeys.users(), "detail", id] as const,

  // Employees
  employees: () => [...superAdminKeys.all, "employees"] as const,
  employeesList: (params: {
    search?: string;
    company_id?: string;
    page?: number;
    size?: number;
  }) => [...superAdminKeys.employees(), "list", params] as const,

  // Groups (per-company)
  groups: (companyId: string) =>
    [...superAdminKeys.company(companyId), "groups"] as const,
  group: (companyId: string, groupId: string) =>
    [...superAdminKeys.groups(companyId), "detail", groupId] as const,

  // Groups (cross-company browse list)
  groupsAll: () => [...superAdminKeys.all, "groups-list"] as const,
  groupsList: (params: {
    search?: string;
    company_id?: string;
    page?: number;
    size?: number;
  }) => [...superAdminKeys.groupsAll(), params] as const,

  // Feature Flags
  featureFlags: () => [...superAdminKeys.all, "feature-flags"] as const,
  companyFlags: (companyId: string) =>
    [...superAdminKeys.featureFlags(), "company", companyId] as const,
  userFlags: (userId: string) =>
    [...superAdminKeys.featureFlags(), "user", userId] as const,

  // Messaging channels (per-company)
  messagingChannels: (companyId: string) =>
    [...superAdminKeys.company(companyId), "messaging-channels"] as const,
} as const;
